import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createListCustomer,
  deleteListCustomer,
  getListCustomerList,
  updateListCustomer,
  getListCountry,
  getAllCustomerSync,
  getLanguageList,
  getPaymentMethodList,
  getDeliveryMethodList,
  getMaturityDatesList,
  getProductPriceClassList,
  getDocumentSetList,
  getListSalesmenList,
} from "../../services/MoloniServices";
import Select from "react-select";

const CustomerMoloni = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [customerData, setCustomerData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
  });

  let errorsObj = {
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [isWareHouseLoading, setIsWareHouseLoading] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setCustomerData({
      id: "",
      vat: "",
      number: "",
      name: "",
      language_id: "",
      qty_copies_document: "",
      notes: "",
      country_id: "",
      address: "",
      zip_code: "",
      city: "",
      email: "",
      website: "",
      phone: "",
      fax: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      discount: "",
      credit_limit: "",
      payment_method_id: "",
      delivery_method_id: "",
      maturity_date_id: "",
      field_notes: "",
      moloni_id: "",
    });

    setErrors("");
  };
  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchTemplate = () => {
    let data = { ...params };
    getListCustomerList(data)
      .then((response) => {
        setCustomerList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchTemplate(data);
    },
    [params],
  );

  const handleWareHouseSync = () => {
    setIsWareHouseLoading(true);

    let data = { company_id: "269134" };
    getAllCustomerSync(data)
      .then((response) => {
        toast.success(response.data.message);

        let data = { ...params };
        getListCustomerList(data)
          .then((response) => {
            setCustomerList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          })
          .finally(() => {
            setIsWareHouseLoading(false);
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsWareHouseLoading(false);
      });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductPriceClassList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setPriceClassList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const onEditDetails = (e, item) => {
    setModifyModal(true);
    setCustomerData({
      id: item?.id,
      vat: item?.vat,
      number: item?.number,
      name: item?.name,
      language_id: item?.language_id,
      qty_copies_document: item?.qty_copies_document,
      notes: item?.notes,
      country_id: item?.country_id,
      address: item?.address,
      zip_code: item?.zip_code,
      city: item?.city,
      email: item?.email,
      website: item?.website,
      phone: item?.phone,
      contact_name: item?.contact_name,
      contact_email: item?.contact_email,
      contact_phone: item?.contact_phone,
      discount: item?.discount,
      credit_limit: item?.credit_limit,
      payment_method_id: item?.payment_method_id,
      delivery_method_id: item?.delivery_method_id,
      maturity_date_id: item?.maturity_date_id,
      field_notes: item?.field_notes,
      moloni_id: item?.moloni_id,
      fax: item?.fax,
      salesman_id: item?.salesman_id,
      price_class_id: item?.price_class_id,
      payment_day: item?.payment_day,
      document_type_id: item?.document_type_id,
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { customer_id: delType, company_id: "269134" };
    deleteListCustomer(data)
      .then((response) => {
        let data = { ...params };

        fetchTemplate(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!customerData.vat) {
      errorObj.vat = `vat is required.`;
      error = true;
    }

    if (!customerData.number) {
      errorObj.number = `Number is required.`;
      error = true;
    }

    if (!customerData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!customerData.language_id) {
      errorObj.language_id = `Language is required.`;
      error = true;
    }

    if (!customerData.qty_copies_document) {
      errorObj.qty_copies_document = `Qty copies document is required.`;
      error = true;
    }

    if (!customerData.address) {
      errorObj.address = `Address is required.`;
      error = true;
    }

    if (!customerData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!customerData.zip_code) {
      errorObj.zip_code = `Zip code is required.`;
      error = true;
    }

    if (!customerData.country_id) {
      errorObj.country_id = `Country is required.`;
      error = true;
    }

    if (customerData.website) {
      const isValidUrl = /^https?:\/\//.test(customerData.website);
      if (!isValidUrl) {
        errorObj.website = "Website must start with http:// or https://";
        error = true;
      }
    }

    if (customerData.email) {
      const isValidGmail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(
        customerData.email,
      );
      if (!isValidGmail) {
        errorObj.email =
          "Email must be a valid Gmail address (e.g., name@gmail.com)";
        error = true;
      }
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
    };

    let updateData = {
      company_id: "269134",
      id: customerData?.id,
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
      customer_id: customerData?.moloni_id,
    };

    if (customerData?.id) {
      updateListCustomer(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setCustomerData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createListCustomer(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setCustomerData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-entities")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-vat ms-auto mb-2">{t("customers")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-vat m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-vat m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        // onClick={handleAddModal}

                        onClick={() => {
                          navigate("/add-customer");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
                          style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}
                          onClick={handleWareHouseSync}
                          disabled={isWareHouseLoading}
                        >
                          {isWareHouseLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("vat")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("number")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {customerList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.vat || "-"}</td>
                                        <td>{item.number}</td>
                                        <td>{item.phone || "-"}</td>
                                        <td>{item.email || "-"}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                // onClick={(e) =>
                                                //   onEditDetails(e, item)
                                                // }

                                                onClick={() => {
                                                  navigate(
                                                    `/update-customer/${item.uuid}`,
                                                    {
                                                      state: item,
                                                    },
                                                  );
                                                }}
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {customerList && customerList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive1  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("vat")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("number")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {customerList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.vat || "-"}</td>
                                        <td>{item.number}</td>
                                        <td>{item.phone || "-"}</td>
                                        <td>{item.email || "-"}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                // onClick={(e) =>
                                                //   onEditDetails(e, item)
                                                // }

                                                onClick={() => {
                                                  navigate(
                                                    `/update-customer/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  );
                                                }}
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {customerList && customerList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div
              className="card-footer card-footer-part clearfix card-footer"
              style={{ marginTop: "-25px" }}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_customer")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this customer")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal} size="xl">
        <ModalHeader>{t("customers")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.vat}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            vat: e.target.value,
                          });
                        }}
                        name={`vat`}
                        maxLength={50}
                        placeholder="vat"
                      />
                    </div>
                    {errors.vat && (
                      <span className="input-error">{errors.vat}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={customerData.number}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            number: e.target.value,
                          });
                        }}
                        name={`number`}
                        maxLength={50}
                        placeholder="number"
                      />
                    </div>
                    {errors.number && (
                      <span className="input-error">{errors.number}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.name}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder="name"
                      />
                    </div>
                    {errors.name && (
                      <span className="input-error">{errors.code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("language")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={languageList}
                        value={languageList.find(
                          (item) => item.value == customerData.language_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            language_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Language"}
                      />
                      {errors.language_id && (
                        <span className="input-error">
                          {errors.language_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("qty_copies_document")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.qty_copies_document}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            qty_copies_document: e.target.value,
                          });
                        }}
                        name={`qty_copies_document`}
                        maxLength={50}
                        placeholder="Qty copies document"
                      />
                    </div>
                    {errors.qty_copies_document && (
                      <span className="input-error">
                        {errors.qty_copies_document}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("notes")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.notes}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            notes: e.target.value,
                          });
                        }}
                        name={`notes`}
                        maxLength={50}
                        placeholder="notes"
                      />
                    </div>
                    {errors.notes && (
                      <span className="input-error">{errors.notes}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={timeZoneList}
                        value={timeZoneList.find(
                          (item) => item.value == customerData.country_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            country_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Country"}
                      />
                      {errors.country_id && (
                        <span className="input-error">{errors.country_id}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.address}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            address: e.target.value,
                          });
                        }}
                        name={`address`}
                        maxLength={50}
                        placeholder="Address"
                      />
                    </div>
                    {errors.address && (
                      <span className="input-error">{errors.address}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.city}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            city: e.target.value,
                          });
                        }}
                        name={`city`}
                        maxLength={50}
                        placeholder="City"
                      />
                    </div>
                    {errors.city && (
                      <span className="input-error">{errors.city}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("zip_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.zip_code}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            zip_code: e.target.value,
                          });
                        }}
                        name={`zip_code`}
                        maxLength={50}
                        placeholder="Zip code"
                      />
                    </div>
                    {errors.zip_code && (
                      <span className="input-error">{errors.zip_code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("phone")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={customerData.phone}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            phone: e.target.value,
                          });
                        }}
                        name={`phone`}
                        placeholder="Phone"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("fax")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={customerData.fax}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            fax: e.target.value,
                          });
                        }}
                        name={`fax`}
                        placeholder="Fax"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.email}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder="Contact email"
                      />
                      {errors.email && (
                        <span className="input-error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("website")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.website}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            website: e.target.value,
                          });
                        }}
                        name={`website`}
                        placeholder="website"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("paymentMethod")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={paymentMethodList}
                        value={paymentMethodList.find(
                          (item) =>
                            item.value == customerData.payment_method_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            payment_method_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Payment Method"}
                      />
                      {errors.payment_method_id && (
                        <span className="input-error">
                          {errors.payment_method_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("deliveryMethod")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={deliveryMethodList}
                        value={deliveryMethodList.find(
                          (item) =>
                            item.value == customerData.delivery_method_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            delivery_method_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Payment Method"}
                      />
                      {errors.delivery_method_id && (
                        <span className="input-error">
                          {errors.delivery_method_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("maturityDates")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={maturityDatesList}
                        value={maturityDatesList.find(
                          (item) => item.value == customerData.maturity_date_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            maturity_date_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Payment Method"}
                      />
                      {errors.maturity_date_id && (
                        <span className="input-error">
                          {errors.maturity_date_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("contact_name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.contact_name}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            contact_name: e.target.value,
                          });
                        }}
                        name={`contact_name`}
                        maxLength={50}
                        placeholder="Contact name"
                      />
                      {errors.contact_name && (
                        <span className="input-error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("contact_email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.contact_email}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            contact_email: e.target.value,
                          });
                        }}
                        name={`contact_email`}
                        maxLength={50}
                        placeholder="Contact Email"
                      />
                      {errors.contact_email && (
                        <span className="input-error">
                          {errors.contact_email}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("contact_phone")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.contact_phone}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            contact_phone: e.target.value,
                          });
                        }}
                        name={`contact_phone`}
                        maxLength={50}
                        placeholder="Contact Phone"
                      />
                      {errors.contact_phone && (
                        <span className="input-error">
                          {errors.contact_phone}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("discount")} %
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={customerData.discount}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            discount: e.target.value,
                          });
                        }}
                        name={`discount`}
                        maxLength={50}
                        placeholder="Discount"
                      />
                      {errors.discount && (
                        <span className="input-error">{errors.discount}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("credit_limit")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={customerData.credit_limit}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            credit_limit: e.target.value,
                          });
                        }}
                        name={`credit_limit`}
                        maxLength={50}
                        placeholder="Credit limit"
                      />
                      {errors.credit_limit && (
                        <span className="input-error">
                          {errors.credit_limit}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("field_notes")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={customerData.field_notes}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            field_notes: e.target.value,
                          });
                        }}
                        name={`field_notes`}
                        maxLength={50}
                        placeholder="Field notes"
                      />
                      {errors.field_notes && (
                        <span className="input-error">
                          {errors.field_notes}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("salesmen")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={salesmenList}
                        value={salesmenList.find(
                          (item) => item.value == customerData.salesman_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            salesman_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Salesmen"}
                      />
                      {errors.salesman_id && (
                        <span className="input-error">
                          {errors.salesman_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("price_class")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={priceClassList}
                        value={priceClassList.find(
                          (item) => item.value == customerData.price_class_id,
                        )}
                        onChange={(selectedOption) => {
                          setCustomerData({
                            ...customerData,
                            price_class_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Price Class "}
                      />
                      {errors.price_class_id && (
                        <span className="input-error">
                          {errors.price_class_id}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("payment_day")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={customerData.payment_day}
                        onChange={(e) => {
                          setCustomerData({
                            ...customerData,
                            payment_day: e.target.value,
                          });
                        }}
                        name={`payment_day`}
                        maxLength={50}
                        placeholder="Payment day"
                      />
                      {errors.payment_day && (
                        <span className="input-error">
                          {errors.payment_day}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3"></div>
              <div className="col-md-3"></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default CustomerMoloni;
